import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import DrawerSimple from "ds/components/DrawerNew/Simple";

import DetailsDrawerContent from "./Content";
import { DETAILS_GROUP_DRAWER_TEST_ID } from "./constants";
import { IdpGroupView } from "../types";

type IdpGroupDetailsDrawerProps = {
  group: IdpGroupView;
};

const IdpGroupDetailsDrawer = createDrawer(({ group }: IdpGroupDetailsDrawerProps) => {
  return (
    <DrawerSimple dataTestId={DETAILS_GROUP_DRAWER_TEST_ID}>
      <DetailsDrawerContent group={group} />
    </DrawerSimple>
  );
});

export const showIdpGroupDetailsDrawer = createDrawerTrigger(IdpGroupDetailsDrawer);
